// frontend/src/components/Layout/Layout.jsx
//
// Persistent application shell: sidebar + main content area.
// <Outlet /> renders whichever module the current route resolves to.
//
// The layout uses CSS Grid with a fixed sidebar column and a fluid
// main column — this is the standard portal/dashboard pattern.

import { Outlet } from 'react-router-dom'
import Sidebar from '../Sidebar/Sidebar'
import styles from './Layout.module.css'

export default function Layout() {
  return (
    <div className={styles.shell}>
      <Sidebar />
      <main className={styles.main}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
